import * as _ from 'lodash';
import { IndicatorLightType } from './indicator-light-type';
import { WordIndicatorLightCondition } from './word-indicator-light-condition';
import { BitIndicatorLightCondition } from './bit-indicator-light-condition';
import { OptionItem } from '../../utils/option-item';
import { Flicker } from '@flexem/fc-gui';
import { FontSizeHelper } from '../../../shared/helpers/font-size-helper';
import { TextAlignHelper } from '../../../shared/helpers/text-align-helper';
import { FontStyleHelper } from '../../../shared/helpers/font-style-helper';
// @dynamic
var IndicatorLightHelper = /** @class */ (function () {
    function IndicatorLightHelper() {
    }
    IndicatorLightHelper.getIndicatorLightTypes = function () {
        return IndicatorLightHelper.indicatorLightTypes;
    };
    IndicatorLightHelper.getBitIndicatorLightConditions = function () {
        return IndicatorLightHelper.bitIndicatorLightConditions;
    };
    IndicatorLightHelper.getBitIndicatorLightCondition = function (condition) {
        switch (condition) {
            case BitIndicatorLightCondition.Off:
                return 'OFF';
            case BitIndicatorLightCondition.On:
                return 'ON';
        }
    };
    IndicatorLightHelper.getWordIndicatorLightConditions = function () {
        return IndicatorLightHelper.wordIndicatorLightConditions;
    };
    IndicatorLightHelper.getWordIndicatorLightCondition = function (condition) {
        switch (condition) {
            case WordIndicatorLightCondition.Equal:
                return '==';
            case WordIndicatorLightCondition.NotEqual:
                return '!=';
            case WordIndicatorLightCondition.GreaterThan:
                return '>';
            case WordIndicatorLightCondition.LessThan:
                return '<';
            case WordIndicatorLightCondition.GreaterOrEqual:
                return '>=';
            case WordIndicatorLightCondition.LessOrEqual:
                return '<=';
        }
    };
    IndicatorLightHelper.getDefaultIndicatorLightSettings = function () {
        return {
            type: IndicatorLightType.Bit,
            settings: {
                variableName: ''
            }
        };
    };
    IndicatorLightHelper.getDefaultIndicatorLightStates = function () {
        return IndicatorLightHelper.getDefaultBitIndicatorLightStates();
    };
    IndicatorLightHelper.getDefaultBitIndicatorLightStates = function () {
        return [
            {
                id: 0, condition: { operator: BitIndicatorLightCondition.Off },
                faultFlicker: _.cloneDeep(this.defaultFaultFlicker),
                text: IndicatorLightHelper.getDefaultLabel()
            },
            {
                id: 1, condition: { operator: BitIndicatorLightCondition.On },
                faultFlicker: _.cloneDeep(this.defaultFaultFlicker),
                text: IndicatorLightHelper.getDefaultLabel()
            }
        ];
    };
    IndicatorLightHelper.getDefaultWordIndicatorLightStates = function () {
        return [
            {
                id: 0, condition: { operator: WordIndicatorLightCondition.Equal, operand: 0 },
                faultFlicker: _.cloneDeep(this.defaultFaultFlicker),
                text: IndicatorLightHelper.getDefaultLabel()
            },
            {
                id: 1, condition: { operator: WordIndicatorLightCondition.Equal, operand: 1 },
                faultFlicker: _.cloneDeep(this.defaultFaultFlicker),
                text: IndicatorLightHelper.getDefaultLabel()
            },
            {
                id: 2,
                text: IndicatorLightHelper.getDefaultLabel()
            }
        ];
    };
    IndicatorLightHelper.getDefaultIndicatorLightSize = function () {
        return '64 64';
    };
    IndicatorLightHelper.getDefaultLabel = function () {
        return {
            content: '',
            font: {
                isUnderline: false,
                fontSize: FontSizeHelper.defaultFontSize,
                fontStyle: FontStyleHelper.getDefaultFontStyle(),
                color: FontStyleHelper.defaultFontColor,
                textAlign: TextAlignHelper.AlignCenter
            }
        };
    };
    IndicatorLightHelper.getFlickers = function () {
        return [
            new OptionItem(Flicker.Nothing, 'Nothing'),
            new OptionItem(Flicker.Image, 'Image'),
            new OptionItem(Flicker.Label, 'Label')
        ];
    };
    IndicatorLightHelper.getFlickerName = function (flicker) {
        var result = _.find(this.getFlickers(), function (item) {
            return item.key === flicker;
        });
        return result ? result.name : '';
    };
    IndicatorLightHelper.defaultFaultFlicker = { flicker: Flicker.Nothing, frequency: 0.5 };
    IndicatorLightHelper.indicatorLightTypes = [
        new OptionItem(IndicatorLightType.Bit, 'BitIndicatorLight'),
        new OptionItem(IndicatorLightType.Word, 'WordIndicatorLight')
    ];
    IndicatorLightHelper.bitIndicatorLightConditions = [
        new OptionItem(BitIndicatorLightCondition.Off, 'OFF'),
        new OptionItem(BitIndicatorLightCondition.On, 'ON')
    ];
    IndicatorLightHelper.wordIndicatorLightConditions = [
        new OptionItem(WordIndicatorLightCondition.Equal, '=='),
        new OptionItem(WordIndicatorLightCondition.NotEqual, '!='),
        new OptionItem(WordIndicatorLightCondition.GreaterThan, '>'),
        new OptionItem(WordIndicatorLightCondition.LessThan, '<'),
        new OptionItem(WordIndicatorLightCondition.GreaterOrEqual, '>='),
        new OptionItem(WordIndicatorLightCondition.LessOrEqual, '<=')
    ];
    return IndicatorLightHelper;
}());
export { IndicatorLightHelper };
